// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__1XniH","balanceDisclaimer":"posDashboard_balanceDisclaimer__1Ih8a"};